var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"center"},_vm._l((_vm.contentList),function(item){return _c('div',{key:item.uuid,staticClass:"items"},[_c('img',{attrs:{"src":item.value,"alt":"","srcset":""}}),_vm._v(" "),_c('p',{staticClass:"title"},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('p',{staticClass:"text"},[_vm._v(_vm._s(item.remarks))])])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-89ec6fe8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homeIndex/advantage.vue
// module id = null
// module chunks = 